<template>
  <div class="mt-5" v-observe-visibility="{
          callback: visibilityChanged,
          once: true,
          rootMargin: '-300px'
        }">
    <section class="bg-blue">
      <div class="container">
        <h2>{{ $t('chancellor_question') }}</h2>

        <i18n tag="p" class="answer" path="chancellor_answer">
          <template v-slot:top_chancellor>
            <span class="emph">{{ topChancellor.title }}</span>
          </template>

          <template v-slot:top_chancellor_percentage>
            <span class="emph">{{ topChancellor.x | percentage(0) }}</span>
          </template>

          <template v-slot:kanzler>{{ kanzler(topChancellor.id) }}</template>
        </i18n>

        <BarChart :data="chartData" v-if="!timecourse & !dashboard" @hover="hovered" :elementHeight="200" />
        <LineChart :data="lineChartData" v-if="timecourse | dashboard" @hover="hovered" :elementHeight="250" :dateFormat="$t('format_date_short')"/>
        <div class="text-center mt-2" v-if="!dashboard">
          <button @click="timecourse = false" class="switch" :class="{active: !timecourse}">{{ $t('other_newest_forecast') }}</button>
          <button @click="timecourse = true" class="switch" :class="{active: timecourse}">{{ $t('other_historical_forecasts') }}</button>
        </div>
      </div>
    </section>
    <section v-if="!dashboard">
      <div class="container">
        <i18n tag="p" path="chancellor_text">
          <template v-slot:sum_of_coalitions>
            <b>{{ $t('chancellor_sum_of_coalitions') }}</b> <a v-on:click="scrollTo('coalition')">{{ $t('other_coalitions')}}</a>.
          </template>
        </i18n>
      </div>
    </section>
  </div>
</template>

<script>
import BarChart from "./BarChart";
 import LineChart from "./LineChart";
import { filter, map } from "lodash";

export default {
  name: "Coalition",
  components: {
    BarChart,
    LineChart,
  },
  data: function () {
    return {
      timecourse: false,
      index: 0,
    };
  },
  computed: {
    chartData() {
      return this.$store.getters.chancellorChartData;
    },
    lineChartData() {
      return this.$store.getters.chancellorLineChartData;
    },
    coalitionProb() {
      return this.$store.getters.coalitionProb;
    },
    topChancellor() {
      if (
        this.chartData &&
        this.chartData.points &&
        this.chartData.points.length > 0
      ) {
        return this.chartData.points[this.index];
      }
      return {
        y: 0,
        title: "NA",
      };
    },
  },
  methods: {
    chancellorPercentage(title) {
      if (
        this.chartData &&
        this.chartData.points &&
        this.chartData.points.length > 0
      ) {
        let point = filter(this.chartData.points, { title: title});
        return point[0].x;
      } else return "NA";
    },
    hovered(id) {
      let ids = map(this.chartData.points, "id");
      let index = ids.indexOf(id);

      if (index > -1) this.index = index;
    },
    coalitionEstimateById(id) {
      if (this.coalitionProb && this.coalitionProb.length > 0) {
        let point = filter(this.coalitionProb, { id: id });
        if (point.length > 0) return point[0].estimate;
        else return 0;
      }
      return 0;
    },
    percParty(id) {
      let forecast = this.$store.getters.forecastTableData;

      if (forecast.length == 0) return 0;

      let party = filter(forecast, { party_id: id })[0];

      return party.forecast;
    },
    visibilityChanged (isVisible) {
      if (isVisible) {
         this.$store.dispatch('getForecast');
         this.$store.dispatch('getCoalitionProb');
      }
    },
    kanzler(id) {
      if (id == 'chancellor-9') return this.$t("chancellor_new_female_chancellor")
      return this.$t("chancellor_new_male_chancellor");
    },
    scrollTo (id) {
      // scroll to correct position
      let navbar = document.getElementsByClassName("navbar-container")[0];
      let question = document.getElementById(id);
      let topOfElement = question.offsetTop - navbar.offsetHeight - 10;
      window.scroll({ top: topOfElement, behavior:'smooth' });
    }
  },
};
</script>
